import { render } from "./MailChangeError.vue?vue&type=template&id=c777624c&scoped=true"
import script from "./MailChangeError.vue?vue&type=script&lang=js"
export * from "./MailChangeError.vue?vue&type=script&lang=js"

import "./MailChangeError.vue?vue&type=style&index=0&id=c777624c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c777624c"]])

export default __exports__